









import {Component, Vue} from 'vue-property-decorator'
import {Getter} from 'vuex-class'

@Component({})
export default class FlashMessage extends Vue {
  @Getter('flash') public flash!: boolean
  @Getter('message') public message!: string
  @Getter('type') public type!: number

    public get typeText() {
      if (this.type === 1) {
          return 'success'
      }
      return 'error'
    }
}
